import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useHistory } from 'react-router-dom'
import copy from 'copy-to-clipboard'
import { toast } from 'react-toastify'

import {
   Button,
   Input,
   InputGroup,
   Loader,
   Qr,
   ThemeIcon,
   WsnToast,
} from '../../../components'

import { currencyFmt, isDesktop } from '../../../utils'
import { fetchAllCoins } from '../../../store/coins'
import DollarImg from '../../../assets/imgs/dollar.svg'
import './Coins.scss'
import TxnList from '../../../components/TxnList'
import dayjs from 'dayjs'
import clsx from 'clsx'
import axios from 'axios'
import { addNotification } from '../../../store/notifications'

const Coins = ({ currentTab, historyFilter }) => {
   const history = useHistory()
   const dispatch = useDispatch()
   const { allCoins, totalBalance, isLoading } = useSelector(
      state => state.coins
   )
   const { isDarkTheme } = useSelector(state => state.theme)
   const { publicKey } = useSelector(state => state.user)

   const CODE = publicKey

   const [coins, setCoins] = React.useState([])
   const [selectedCoin, setSelectedCoin] = React.useState()
   const [transactions, setTransactions] = React.useState([])
   const [selectedTxn, setSelectedTxn] = React.useState()
   const [balance, setBalance] = React.useState(0)
   const [search, setSearch] = React.useState('')
   

   // Send
   const RATE = 357.32

   const { privateKey } = useSelector(state => state.user)
   const [recipient, setRecipient] = React.useState('')
   const [amount, setAmount] = React.useState(0)
   const [unitToSend, setUnitToSend] = React.useState(selectedCoin?.unit)
   const [transactionFlag, setTransactionFlag] = React.useState(false)

   const renderConversion = () => {
      if (unitToSend === selectedCoin?.unit) {
         return `~${currencyFmt(amount * selectedCoin.currentAmount)} USD`
      } else {
         return `~${amount / selectedCoin.currentAmount} ${selectedCoin?.unit}`
      }
   }

   React.useEffect(() => {
      if (allCoins.length) {
         setCoins(allCoins)
         setSelectedCoin(allCoins?.[0])
      } else {
         dispatch(fetchAllCoins())
      }
      setBalance(totalBalance)
   }, [allCoins, allCoins.length, dispatch, totalBalance])

   React.useEffect(() => {
      ;(async () => {
         if (selectedCoin) {
            setUnitToSend(selectedCoin.unit)
            let response = await axios.post(
               `${process.env.REACT_APP_API_URL}/api/wallet/getAllTransactions`,
               { publicKey }
            )
            if (response.data.data) {
               setTransactions(response.data.data)
            }
         }
      })()
   }, [publicKey, selectedCoin, selectedCoin?.id])

   const handleSearch = e => {
      const { value } = e.target
      setSearch(value)
      const query = value.trim().toLowerCase()
      if (!query) {
         setCoins([...allCoins])
      } else {
         const result = allCoins.filter(
            coin =>
               coin.name.toLowerCase().includes(query) ||
               coin.unit.toLowerCase().includes(query)
         )
         setCoins(result)
      }
   }

   const sendCoins = async () => {
      setTransactionFlag(true)
      try{
         const response = await axios.post(`${process.env.REACT_APP_API_URL}/api/token/sendTokenTransaction`, {
                              privateKey,
                              receiverAddress: recipient,
                              contractAddress: selectedCoin.address,
                              amountInEther: amount,
                           })
         console.log(response)
         const heading = 'Transaction receipt!'
         const description = `Sent ${amount} ${unitToSend} to ${recipient}`
   
         dispatch(addNotification({ heading, description }))
         // url is optional
         toast(
            <WsnToast
               heading={heading}
               message={description}
               url={'https://bscscan.com/tx/' + response.data.data.hash}
            />
         )
      }catch(e){
         setTransactionFlag(false)
      }
      setTransactionFlag(false)
   }

   const renderPanelContent = () => {
      if (!selectedCoin) return null

      if (currentTab === 'History') {
         return (
            <div className="DesktopCoins__history">
               <div className="DesktopCoins__history-list">
                  <TxnList
                     transactions={transactions}
                     ticker={selectedCoin.unit}
                     onTxnClick={txn => setSelectedTxn(txn)}
                     isDarkTheme={isDarkTheme}
                  />
               </div>
               <div className="DesktopCoins__history-panel">
                  <div className="DesktopCoins__history-panel-header">
                     <img
                        className="DesktopCoins__history-panel-header-img"
                        src={selectedCoin.image}
                        alt={selectedCoin.name}
                     />
                     <h3 className="DesktopCoins__history-panel-header-name">
                        {selectedCoin.name}
                     </h3>
                  </div>
                  <div className="DesktopCoins__history-panel-label">
                     Wallet balance:
                  </div>
                  <div className="DesktopCoins__history-panel-balance">
                     {selectedCoin.value}
                     {selectedCoin.unit}
                  </div>
                  <div className="DesktopCoins__history-panel-balance-usd">
                     {currencyFmt(selectedCoin.investedAmount)}
                  </div>
                  <div className="DesktopCoins__history-panel-txn">
                     {selectedTxn ? (
                        <>
                           <div
                              className={clsx(
                                 'DesktopCoins__history-panel-txn-value',
                                 selectedTxn.type === 'RECEIVED' &&
                                    'DesktopCoins__history-panel-txn-value--green'
                              )}
                           >
                              {selectedTxn.value}
                           </div>
                           <div className="DesktopCoins__history-panel-card">
                              <div className="DesktopCoins__history-panel-card-row">
                                 <h4 className="DesktopCoins__history-panel-card-row-key">
                                    Date
                                 </h4>
                                 <h4 className="DesktopCoins__history-panel-card-row-value">
                                    {dayjs(selectedTxn.createdAt).format(
                                       'DD MMM YY'
                                    )}
                                 </h4>
                              </div>
                              <div className="DesktopCoins__history-panel-card-row">
                                 <h4 className="DesktopCoins__history-panel-card-row-key">
                                    Status
                                 </h4>
                                 <h4 className="DesktopCoins__history-panel-card-row-value">
                                    {selectedTxn.status}
                                 </h4>
                              </div>
                              <div className="DesktopCoins__history-panel-card-row">
                                 <h4 className="DesktopCoins__history-panel-card-row-key">
                                    Recipient
                                 </h4>
                                 <h4 className="DesktopCoins__history-panel-card-row-value">
                                    {selectedTxn.recipient}
                                 </h4>
                              </div>
                           </div>
                           <div className="DesktopCoins__history-panel-card">
                              <div className="DesktopCoins__history-panel-card-row">
                                 <h4 className="DesktopCoins__history-panel-card-row-key">
                                    Network Fee
                                 </h4>
                                 <h4 className="DesktopCoins__history-panel-card-row-value">
                                    {selectedTxn.fee}
                                 </h4>
                              </div>
                              <div className="DesktopCoins__history-panel-card-row">
                                 <h4 className="DesktopCoins__history-panel-card-row-key">
                                    Nonce
                                 </h4>
                                 <h4 className="DesktopCoins__history-panel-card-row-value">
                                    {selectedTxn.nonce}
                                 </h4>
                              </div>
                           </div>
                        </>
                     ) : (
                        <div className="DesktopCoins__history-panel-txn-empty">
                           Select Transaction
                        </div>
                     )}
                  </div>
               </div>
            </div>
         )
      }

      if (currentTab === 'Send') {
         return (
            <div className="DesktopCoins__send">
               <div className="DesktopCoins__send-left">
                  <h3 className="DesktopCoins__send-header">Send {unitToSend}</h3>
                  <InputGroup
                     id="recipient"
                     className="DesktopCoins__send-recipient"
                     label="Recipient Address"
                     placeholder="Add here"
                     value={recipient}
                     onChange={e => setRecipient(e.target.value)}
                     right={
                        <span className="DesktopCoins__send-recipient-paste">
                           Paste
                        </span>
                     }
                     isDarkTheme={isDarkTheme}
                  />
                  <InputGroup
                     id="amount"
                     className="DesktopCoins__send-amount"
                     label={`Amount ${unitToSend}`}
                     placeholder="Add here"
                     value={amount}
                     onChange={e => setAmount(e.target.value)}
                     right={
                        <span
                           onClick={() =>
                              setUnitToSend(
                                 unitToSend === selectedCoin.unit
                                    ? 'USD'
                                    : selectedCoin.unit
                              )
                           }
                           className="DesktopCoins__send-amount-unit"
                        >
                           {unitToSend}
                        </span>
                     }
                     isDarkTheme={isDarkTheme}
                  />
                  <div className="DesktopCoins__send-conversion">
                     {renderConversion()}
                  </div>
                  <div className="DesktopCoins__send-fee">
                     Network Fee: <span>$0.33</span>
                  </div>
                  <div className="DesktopCoins__send-balance">
                     Wallet Balance:{' '}
                     <span>
                        {selectedCoin.value} {selectedCoin.unit}
                     </span>
                  </div>
                  {
                     transactionFlag?
                     <Button
                        className="DesktopCoins__send-cta"
                        variant="solid"
                        color="gray"
                        size="lg"
                        isDarkTheme={isDarkTheme}
                        fullWidth
                     >
                        Send
                     </Button>
                     :
                     <Button
                        className="DesktopCoins__send-cta"
                        variant="solid"
                        color="primary"
                        size="lg"
                        isDarkTheme={isDarkTheme}
                        fullWidth
                        onClick={sendCoins}
                     >
                        Send
                     </Button>
                  }
               </div>
               <div className="DesktopCoins__send-right">
                  <img
                     className="DesktopCoins__send-right-img"
                     src={DollarImg}
                     alt="Send Coin"
                  />
                  <div className="DesktopCoins__send-right-text">
                     Instantly send your coins or token
                  </div>
               </div>
            </div>
         )
      }

      if (currentTab === 'Receive') {
         return (
            <div className="DesktopCoins__receive">
               <h3 className="DesktopCoins__receive-header">Receive BNB</h3>
               <div className="DesktopCoins__receive-grid">
                  <div className="DesktopCoins__receive-grid-left">
                     <h4 className="DesktopCoins__receive-label">
                        Wallet Balance:
                     </h4>
                     <h4 className="DesktopCoins__receive-balance">
                        {selectedCoin.value} {selectedCoin.unit}
                     </h4>
                     <h6 className="DesktopCoins__receive-balance-usd">
                        {selectedCoin.investedAmount.toFixed(2)} USD
                     </h6>
                     <h4 className="DesktopCoins__receive-label">
                        Wallet Address:
                     </h4>
                     <p className="DesktopCoins__receive-address">{CODE}</p>
                     <ThemeIcon
                        className="DesktopCoins__receive-copy"
                        name="clone"
                        onClick={() => copy(CODE)}
                     />
                  </div>
                  <div className="DesktopCoins__receive-grid-right">
                     <h3 className="DesktopCoins__receive-wsn">
                        WallStreetNinja
                     </h3>
                     <Qr
                        className="DesktopCoins__receive-qr"
                        code={CODE}
                        width={238}
                     />
                  </div>
                  <p className="DesktopCoins__receive-disclaimer">
                     Send only BNB to this address. <br />
                     Sending any other coins may result in permanent loss
                  </p>
               </div>
            </div>
         )
      }
   }

   if (isDesktop()) {
      return (
         <div
            className={clsx(
               'DesktopCoins',
               isDarkTheme && 'DesktopCoins--dark'
            )}
         >
            <div className="DesktopCoins__left">
               <div className="DesktopCoins__left-header">
                  {currencyFmt(balance)}
               </div>
               <div className="DesktopCoins__list">
                  {coins.map(coin => (
                     <div
                        className="DesktopCoins__list-card"
                        key={coin.id}
                        onClick={() => setSelectedCoin(coin)}
                     >
                        <img
                           src={coin.image}
                           alt={coin.name}
                           className="DesktopCoins__list-card-image"
                           loading="lazy"
                        />
                        <div className="DesktopCoins__list-card-content">
                           <div className="DesktopCoins__list-card-content-top">
                              <h3 className="DesktopCoins__list-card-content-top-name">
                                 {coin.name}
                              </h3>
                              <h4 className="DesktopCoins__list-card-content-top-value">
                                 {coin.value} {coin.unit}
                              </h4>
                           </div>
                           <div className="DesktopCoins__list-card-content-bottom">
                              <small className="DesktopCoins__list-card-content-bottom-amount">
                                 {currencyFmt(coin.currentAmount)}{' '}
                                 <span
                                    className={clsx(
                                       'DesktopCoins__list-card-content-bottom-amount-change',
                                       coin.change < 0 &&
                                          'DesktopCoins__list-card-content-bottom-amount-change--negative'
                                    )}
                                 >
                                    {coin.change}
                                 </span>
                              </small>
                              <small className="DesktopCoins__list-card-content-bottom-amount">
                                 {currencyFmt(coin.investedAmount)}
                              </small>
                           </div>
                        </div>
                     </div>
                  ))}
               </div>
            </div>
            <div className="DesktopCoins__right">{renderPanelContent()}</div>
         </div>
      )
   }

   if (isLoading) return <Loader />
   return (
      <div className={clsx('Coins', isDarkTheme && 'Coins--dark')}>
         <h2 className="Coins__balance">{currencyFmt(balance)}</h2>
         <Input
            value={search}
            onChange={handleSearch}
            placeholder="search"
            className="Coins__search"
            isDarkTheme={isDarkTheme}
         />
         <div className="Coins__list">
            {coins.map(coin => (
               <div
                  className="Coins__list-card"
                  key={coin.id}
                  onClick={() => history.push(`/coin/${coin.id}`)}
               >
                  <img
                     src={coin.image}
                     alt={coin.name}
                     className="Coins__list-card-image"
                     loading="lazy"
                  />
                  <div className="Coins__list-card-content">
                     <div className="Coins__list-card-content-top">
                        <h3 className="Coins__list-card-content-top-name">
                           {coin.name}
                        </h3>
                        <h4 className="Coins__list-card-content-top-value">
                           {coin.value} {coin.unit}
                        </h4>
                     </div>
                     <div className="Coins__list-card-content-bottom">
                        <small className="Coins__list-card-content-bottom-amount">
                           {currencyFmt(coin.currentAmount)}{' '}
                           <span
                              className={clsx(
                                 'Coins__list-card-content-bottom-amount-change',
                                 coin.change < 0 &&
                                    'Coins__list-card-content-bottom-amount-change--negative'
                              )}
                           >
                              {coin.change}
                           </span>
                        </small>
                        <small className="Coins__list-card-content-bottom-amount">
                           {currencyFmt(coin.investedAmount)}
                        </small>
                     </div>
                  </div>
               </div>
            ))}
         </div>
      </div>
   )
}

export default Coins
